/**
 * Social-Media-Felder: erkennt beim Einfügen die Plattform anhand der URL und
 * normalisiert den Wert (URL behalten, sonst Handle/Freitext). Reine Funktionen.
 */

export type SocialPlatform =
  | "linkedin"
  | "instagram"
  | "facebook"
  | "tiktok"
  | "xing"
  | "youtube";

const HOST_MAP: Array<{ re: RegExp; platform: SocialPlatform }> = [
  { re: /(^|\.)linkedin\.com$/i, platform: "linkedin" },
  { re: /(^|\.)instagram\.com$/i, platform: "instagram" },
  { re: /(^|\.)(facebook\.com|fb\.com)$/i, platform: "facebook" },
  { re: /(^|\.)tiktok\.com$/i, platform: "tiktok" },
  { re: /(^|\.)xing\.com$/i, platform: "xing" },
  { re: /(^|\.)(youtube\.com|youtu\.be)$/i, platform: "youtube" },
];

/** Plattform aus einer (ggf. schemalosen) URL ableiten, sonst undefined. */
export function detectSocialPlatform(input: string): SocialPlatform | undefined {
  const v = (input ?? "").trim();
  if (!v) return undefined;
  try {
    const url = new URL(/^https?:\/\//i.test(v) ? v : `https://${v}`);
    const host = url.hostname.replace(/^www\./i, "");
    for (const { re, platform } of HOST_MAP) if (re.test(host)) return platform;
  } catch {
    /* keine URL → kein Treffer */
  }
  return undefined;
}

/**
 * Normalisiert den Wert eines Plattform-Felds:
 * - vollständige URL → behalten
 * - bekannter Host ohne Schema → https:// voranstellen
 * - sonst (Handle/Freitext) → unverändert
 */
export function normalizeSocialValue(_platform: SocialPlatform, input: string): string {
  const v = (input ?? "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  if (detectSocialPlatform(v)) return `https://${v.replace(/^\/+/, "")}`;
  return v;
}
